import './ClientAccess.css'
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import NewSubClient from '../NewSubClient/NewSubClient';
import { useCallback, useEffect, useMemo, useState } from 'react';
import SubClientList from '../SubClientList/SubClientList';
import { getClientSubClients } from '../../utilities/api/subClients';


export default function ClientAccess({user, client, toggleNotifications}) {
    const [subClients, setSubClients] = useState([]);

    const userId = useMemo(() => user?._id, [user?._id]);
    const clientId = useMemo(() => client?._id, [client?._id]);
    const getSubClients = useCallback(async () => {
        if (!userId || !clientId) return;
        try {
            const response = await getClientSubClients(userId, clientId);
            setSubClients(response);
        } catch (error) {
            console.error('Error fetching sub-clients:', error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientId]);


    const updateSubClients = useCallback(async (newSubClients) => {
        setSubClients(newSubClients);
    }, []);

    useEffect(() => {
        getSubClients();
    }, [getSubClients]);
    
  return (
    <div className='ClientAccess modal fade ClientAccessModal' id='clientAccessModal' data-bs-keyboard="false"  aria-labelledby={`ClientAccessHeader`}>
        <div className='modal-dialog'>
            <div className='modal-content'>
                <div className='modal-header'>
                    <div className='headerContent'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" fill="currentColor" className="bi bi-person-circle" viewBox="0 0 16 16">
                            <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"></path>
                            <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1">
                            </path>
                        </svg>
                        <div>
                            <div className='firstHeader'>Client Access Credentials</div>
                            <div className='secondHeader'>{capitalizeFirstLetter(client.companyName)}</div>
                        </div>
                    </div>
                    <div className='right'>
                        <svg data-bs-dismiss="modal" width="25" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="16.2666" cy="16.2666" r="15.7666" fill="#EDEFF2" stroke="#EEEEEE"/>
                        <path d="M21.1093 12L12 21.1093M12 12L21.1093 21.1093" stroke="#1B2B41" strokeOpacity="0.8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
                <div className='modal-body'>
                    <SubClientList user={user} client={client} subClients={subClients} updateSubClients={updateSubClients} toggleNotifications={toggleNotifications}/>
                    <NewSubClient user={user} client={client} subClients={subClients} updateSubClients={updateSubClients} toggleNotifications={toggleNotifications}/>
                </div>
            </div>
        </div>
    </div>
  )
}
